const stageConfig = {
  CLIENT_HOST: 'majstg-league-live.sunrun.com',
  MIXPANEL_KEY: '8a134cc931ee96d2b60510acfade3a11',
};

export default stageConfig;
